export const SOURCE_STATUS_STEPS = ["Pending", "Confirmed", "Picked", "Shipped", "Delivered"];

const NEXT_STATUS = Object.freeze({
  "Verifying Payment": "Confirmed",
  Pending: "Confirmed",
  Confirmed: "Picked",
  Picked: "Shipped",
  Shipped: "Delivered",
});

const TERMINAL_STATUSES = new Set(["Cancelled", "Delivered", "Returned", "Refunded", "Payment Failed"]);

export const getNextSourceStatus = (status) => NEXT_STATUS[status] || null;

export const canMutateSource = (order, source) => Number(order?.is_spam) === 0 && !TERMINAL_STATUSES.has(source?.status);

export const canReturnSource = (source) => source?.status === "Shipped";

export const canMoveItemToMall = (source) => source?.status === "Pending" && source?.shop_name?.trim().toLowerCase() !== "techbazaar mall";

export const getOrderRisk = (order) => {
  if (Number(order?.is_spam) === 1) return { label: "Spam", tone: "danger" };
  if (order?.potential_spam) return { label: "Potential spam", tone: "warning" };
  return null;
};
